export enum AccessProfile {
  ADMINISTRATOR = 1,
  NATIONAL_INTERLOCUTOR = 2,
  REGIONAL_INTERLOCUTOR = 3,
  EVALUATION_COORDINATOR = 4,
  EVALUATOR = 5,
  DEVELOPER = 6,
}